const Typography = require("typography");

const headerFontFamily = "Poppins";
const headerFontWeights = ["400", "400i", "500", "500i", "600", "700", "700i"];

const bodyFontFamily = "Karma";
const bodyFontWeights = ["400", "400i&display=swap"];

const fontFallbacks = [
  "-apple-system",
  "BlinkMacSystemFont",
  "Segoe UI",
  "Roboto",
  "Helvetica Neue",
  "Arial",
  "Noto Sans",
  "sans-serif",
  "Apple Color Emoji",
  "Segoe UI Emoji",
  "Segoe UI Symbol",
  "Noto Color Emoji"
];

function getHeaderFontAsArray() {
  return [headerFontFamily, ...fontFallbacks];
}

function getBodyFontAsArray() {
  return [bodyFontFamily, ...fontFallbacks];
}

function getHeaderFontAsString() {
  return getHeaderFontAsArray().join(" , ");
}

function getBodyFontAsString() {
  return getBodyFontAsArray().join(" , ");
}

const typography = new Typography({
  headerFontFamily: getHeaderFontAsArray(),
  bodyFontFamily: getBodyFontAsArray(),
  googleFonts: [
    {
      name: headerFontFamily,
      styles: headerFontWeights
    },
    {
      name: bodyFontFamily,
      styles: bodyFontWeights
    }
  ]
});

module.exports = {
  getHeaderFontAsArray,
  getHeaderFontAsString,
  getBodyFontAsArray,
  getBodyFontAsString,
  typography
};
